<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="500px" transition="dialog-transition">
    <v-card>
      <v-card-title primary-title class="mb-3">
        Para continuar com o atendimento, é necessário preencher seus dados
      </v-card-title>
      <v-card-text>
        <div v-if="loading" class="d-flex justify-center align-center py-6">
          <v-progress-circular :value="20" indeterminate></v-progress-circular>
        </div>
        <v-form v-else ref="form">
          <v-row>
            <v-col cols="12" class="my-0 py-0">
              E-mail
              <v-text-field v-model="form.email" type="email" solo flat dense placeholder="Digite aqui seu e-mail"
                class="custom-textfield mt-1" :rules="[
                  () => $v.form.email.required || 'Campo obrigatório',
                  () => $v.form.email.email || 'E-mail inválido'
                ]" />
            </v-col>
            <v-col cols="12" class="my-0 py-0">
              Celular
              <v-text-field v-model="form.fone" solo flat dense v-mask="['(##) #####-####', '(##) ####-####']"
                placeholder="Digite aqui seu celular" class="custom-textfield mt-1" :rules="[
                  () => $v.form.fone.required || 'Campo obrigatório',
                  () => $v.form.fone.minLength || 'Celular inválido'
                ]" />
            </v-col>
            <v-col cols="12" class="my-0 py-0">
              <v-checkbox v-model="form.termos" :rules="[v => !!v || 'Você precisa aceitar os termos']" hide-details="auto">
                <template #label>
                  <span class="text-caption">
                    Li e aceito o termo de consentimento para tratamento de dados pessoais a
                    <span class="text-primary cursor-pointer">
                      <a @click.stop="openLGPD">
                        (LGPD)
                      </a>
                    </span>
                  </span>
                </template>
              </v-checkbox>
            </v-col>
            <v-col class="justify-center text-center">
              <v-btn color="primary" rounded :loading="loadingUpdate" :disabled="loadingUpdate" @click="save">
                Salvar e continuar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <LgpdDialog v-model="showLgpdDialog" />
  </v-dialog>
</template>

<script>
import userService from '@/services/user'
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'
import { extractOnlyNumbers } from '@/utils/formatter'
import { mapMutations } from 'vuex'
import LgpdDialog from './LgpdDialog.vue'

export default {
  components: {
    LgpdDialog
  },
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      email: {
        required,
        email
      },
      fone: {
        required,
        minLength: minLength(14)
      }
    }
  },
  data() {
    return {
      dialog: true,
      loading: false,
      loadingUpdate: false,
      showLgpdDialog: false,
      form: {
        email: '',
        fone: '',
        termos: false
      }
    }
  },
  watch: {
    value(val) {
      this.dialog = val
    },
    dialog(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    ...mapMutations('user', ['SET_EMAIL']),
    formatPhone(fone) {
      if (!fone) return ''
      const digits = String(fone).replace(/\D/g, '')
      if (digits.length === 11) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
      }
      if (digits.length === 10) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`
      }
      return fone
    },
    openLGPD() {
      this.showLgpdDialog = true
    },
    async getUserData() {
      try {
        this.loading = true
        const { data } = await userService.verificaDadosContato()
        this.form.email = data.email || ''
        this.form.fone = this.formatPhone(data.fone)
        this.form.termos = !!data.termos
      } catch ({ response }) {
        this.$showErrorMessage(response?.data?.message || 'Erro ao carregar dados')
        this.dialog = false
      } finally {
        this.loading = false
      }
    },
    async save() {
      if (!this.$refs.form.validate()) return

      try {
        this.loadingUpdate = true
        const params = {
          email: this.form.email,
          fone: extractOnlyNumbers(this.form.fone),
          termos: this.form.termos
        }
        await userService.updateDadosContato(params)
        this.SET_EMAIL(this.form.email)
        this.$showSuccessMessage('Dados confirmados')
        this.$emit('dados-confirmados')
        this.dialog = false
      } catch ({ response }) {
        this.$showErrorMessage(response?.data?.message || 'Erro ao salvar dados')
      } finally {
        this.loadingUpdate = false
      }
    }
  },
  mounted() {
    this.getUserData()
  }
}
</script>
